import { useEffect, useState } from 'react'
import { api } from '../lib/api'

export default function ProgressPage() {
  const [summary, setSummary] = useState<any>(null)
  const [logs, setLogs] = useState<any[]>([])
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ weight: '', waist: '', chest: '', notes: '' })

  useEffect(() => {
    api.getProgressSummary().then(setSummary).catch(() => {})
    api.getProgressHistory().then(({ logs }) => setLogs(logs)).catch(() => {})
  }, [])

  async function handleLog(e: React.FormEvent) {
    e.preventDefault()
    try {
      const data: any = {}
      if (form.weight) data.weight = parseFloat(form.weight)
      if (form.waist) data.waist = parseFloat(form.waist)
      if (form.chest) data.chest = parseFloat(form.chest)
      if (form.notes) data.notes = form.notes

      await api.logProgress(data)
      setForm({ weight: '', waist: '', chest: '', notes: '' })
      setShowForm(false)
      // Refresh
      api.getProgressSummary().then(setSummary)
      api.getProgressHistory().then(({ logs }) => setLogs(logs))
    } catch (err: any) {
      alert(err.message)
    }
  }

  const weightChange = summary?.earliest?.weight && summary?.latest?.weight
    ? (summary.latest.weight - summary.earliest.weight).toFixed(1)
    : null

  return (
    <div>
      <div className="page-header">
        <h2>Progress Tracker</h2>
        <p>See and feel better — the numbers don't lie.</p>
      </div>

      {/* Summary */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{summary?.latest?.weight ? `${summary.latest.weight}` : '—'}</div>
          <div className="stat-label">Current Weight (lbs)</div>
        </div>
        <div className="stat-card">
          <div className="stat-value" style={{ color: weightChange && parseFloat(weightChange) < 0 ? 'var(--accent-green)' : weightChange && parseFloat(weightChange) > 0 ? 'var(--accent-red)' : 'var(--gold)' }}>
            {weightChange ? `${parseFloat(weightChange) > 0 ? '+' : ''}${weightChange}` : '—'}
          </div>
          <div className="stat-label">Weight Change (lbs)</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{summary?.totalLogs || 0}</div>
          <div className="stat-label">Check-ins</div>
        </div>
      </div>

      {/* Log form */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Log Progress</span>
          <button className="btn btn-secondary" onClick={() => setShowForm(!showForm)} style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}>
            {showForm ? 'Close' : '+ Check In'}
          </button>
        </div>

        {showForm && (
          <form onSubmit={handleLog}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '0.75rem' }}>
              <div className="form-group">
                <label className="form-label">Weight (lbs)</label>
                <input type="number" step="0.1" className="form-input" value={form.weight} onChange={e => setForm(prev => ({ ...prev, weight: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Waist (in)</label>
                <input type="number" step="0.1" className="form-input" value={form.waist} onChange={e => setForm(prev => ({ ...prev, waist: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Chest (in)</label>
                <input type="number" step="0.1" className="form-input" value={form.chest} onChange={e => setForm(prev => ({ ...prev, chest: e.target.value }))} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Notes</label>
              <input type="text" className="form-input" placeholder="How are you feeling?" value={form.notes} onChange={e => setForm(prev => ({ ...prev, notes: e.target.value }))} />
            </div>
            <button type="submit" className="btn btn-primary">Save Progress</button>
          </form>
        )}
      </div>

      {/* History */}
      <div className="card" style={{ marginTop: '1rem' }}>
        <div className="card-header">
          <span className="card-title">History</span>
        </div>
        {logs.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem 0' }}>No progress logs yet. Start tracking!</p>
        ) : (
          logs.map(log => (
            <div key={log.id} className="quest-item">
              <span className="quest-icon">📏</span>
              <div className="quest-info">
                <div className="quest-name">{new Date(log.date).toLocaleDateString()}</div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                  {log.weight && `${log.weight} lbs`}
                  {log.waist && ` · ${log.waist}" waist`}
                  {log.chest && ` · ${log.chest}" chest`}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
